// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const disabledStyle = {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[200],
    },
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        contained: {
          ...disabledStyle,
        },
        outlined: {
          ...disabledStyle,
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success,
        },
        containedError: {
          boxShadow: theme.customShadows.error,
        },
      },
    },
  };
}
